var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 4.16667V13.75C7.91667 15.5917 6.425 17.0833 4.58333 17.0833C2.74167 17.0833 1.25 15.5917 1.25 13.75V3.33333C1.25 2.18333 2.18333 1.25 3.33333 1.25C4.48333 1.25 5.41667 2.18333 5.41667 3.33333V12.0833C5.41667 12.5417 5.04167 12.9167 4.58333 12.9167C4.125 12.9167 3.75 12.5417 3.75 12.0833V4.16667H2.5V12.0833C2.5 13.2333 3.43333 14.1667 4.58333 14.1667C5.73333 14.1667 6.66667 13.2333 6.66667 12.0833V3.33333C6.66667 1.49167 5.175 0 3.33333 0C1.49167 0 0 1.49167 0 3.33333V13.75C0 16.2833 2.05 18.3333 4.58333 18.3333C7.11667 18.3333 9.16667 16.2833 9.16667 13.75V4.16667H7.91667Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadButton);
export default __webpack_public_path__ + "static/media/UploadButton.9dae7b2906a74190c1c498e529771afb.svg";
export { ForwardRef as ReactComponent };